module.exports = __webpack_public_path__ + "66901c7f672e02301702824039fbaa5b.jpg";